const stopPays = {
    title: 'Предупреждение',
    description:
        'Все отправленные на подпись исполнителям платежи <b>будут возвращены</b>. После возврата у них будет проставлен <b>односторонний порядок</b> подписания.',
    buttonText: 'Откатить',
} as const;

export default stopPays;
